import { createStore } from "vuex";
import { auth } from "./modules/auth";
import { menu } from "./modules/menu";

const store = createStore({
    strict: true,
    modules : {
        auth,
        menu
    }
});

export default store
